// ======== plugin import ========= //
import {React, useState, useEffect } from 'react'
import Select from 'react-select'
import axios from 'axios'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { notification } from 'antd';
// ========== module import ========= //
import SAISVG from '../../../../../_template/helpers/CommonFunction';
import customStyle from '../../../../../cssModule/custom.module.css';
import { ValidateEmail } from '../../../../component/common/Helper';

// =========== component import ========= //
import ValidationMessage from '../../../../component/common/ValidationMessage';
import ButtonLoader from '../../../../component/common/ButtonLoader';
const AgentAddForm = (props) => {
    const [api, contextHolder] = notification.useNotification();
    const { totalAgentCount, agentUpdateData } = props;

    const loginUserType = localStorage.getItem('type');
    const api_base_url = process.env.REACT_APP_API_URL;

    const [isVisible, setIsVisible] = useState(false);
    
    // ============ Form close handller ============= //
    const AgentFormCloseHandler = (e) => {
        setIsVisible(false);
    }
    // =========== system user handller =========== //
    const AddAgentHandler = (e) => {
        setIsVisible(true);
    }

    // ---------- get product list --------- //

    const [channelList, setChannelList] = useState([]);
    const [botData, setBotData] = useState([]);

    // const getProductList = async () => {

    //     const api_headers = {
    //         headers: {
    //             "Content-Type": "application/json",
    //             "Accept": "application/json",
    //             "x-access-token" : localStorage.getItem('token')
    //         }
    //     };
    //     await axios.post(`${api_base_url}admin/get-select-product-list`,{}, api_headers)
    //     .then(async (res) => {
    //         if(res.data.status === 'success') {
    //             var resProductList = res.data.data.product_list;
    //             const formattedProduct = resProductList.map(product => ({
    //                 value: product.unique_id,
    //                 label: product.product_name
    //             }));
    //             setProductList(formattedProduct)
    //         } else if(res.data.status === 'error') {
                    // api["error"]({
                    //     message: 'Error',
                    //     description: res.data.message
                    // });
    //         }
    //     })
    //     .catch((error) => {
    //         console.error(error);
    //     })
    // }

    const getChannelType = async() =>{
        let apiToken = '';
        if(loginUserType === 'A') {
            apiToken = localStorage.getItem('token')
        } else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }
        const api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        await axios.post(`${api_base_url}admin/get-language-and-channel`,{sass_id: localStorage.getItem('sass_id')}, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                var resChannelList = res.data.data.channel_list;
                const formattedChannel = resChannelList.map(channel => ({
                    value: channel.unique_id,
                    label: channel.channel_name
                }));
                setChannelList(formattedChannel)
            } else if(res.data.status === 'error') {
                api["error"]({
                    message: 'Error',
                    description: res.data.message
                });
            }
        })
        .catch((error) => {
            console.error(error);
        })
    }

    const getAllBot = async() => {
        let apiToken = '';
        if(loginUserType === 'A') {
            apiToken = localStorage.getItem('token')
        } else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }

        const api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        
        await axios.post(`${api_base_url}admin/get-all-bot`, {sass_id: localStorage.getItem('sass_id')}, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                const result = res.data.data.map((item, index) => ({
                    label: item.bot_name,
                    value: item.bot_id
                }));
                setBotData(result);
            } else if(res.data.status === 'error') {
                api["error"]({
                    message: 'Error',
                    description: res.data.message
                });
            }
        })
        .catch((error) => {
            console.error(error);
        })
    }
    
    useEffect(() => {
        // getProductList();
        getChannelType();
        getAllBot();
    },[]);

    useEffect(() => {
        if(props.editButton) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    }, [props.editButton])

    // ------------ password shown and hide ------------- //
    const [passwordShown, setPasswordShown] = useState(false);
    const togglePasswordVisibility = () => {
        setPasswordShown(!passwordShown)
    }

    //=========== get value and validation ========//
    const [agentFormData, setAgentFormData] = useState({
        full_name : "", 
        agent_email : "" ,
        assign_bot : [],
        channel_type: [],
        user_name : "",
        password : "",
        agent_update_id : "",
        agent_old_user_name : "",
        sass_id: localStorage.getItem('sass_id'),
        type: loginUserType,
        login_user_name: loginUserType == 'SA' ? localStorage.getItem('system_username') : ''
    });

    const validateField = (name, value) => {
        let error = "";
        if (name === "full_name") {
            if (!value) {
                error = "Full name is required";
            } 
        }
        if(name === 'agent_email'){
            if (!value) {
                error = "Agent email is required";
            }
            else if (!ValidateEmail(value)) {
                error = "Invalid email address";
            }
        }
        if(name === 'assign_bot'){
            if (!value || (Array.isArray(value) && value.length === 0)) {
                error = "Please select at least one Bot.";
            }
        }
        if(name === 'channel_type'){
            if( !value || Object.keys(value).length === 0 || (Array.isArray(value) && value.length === 0)){
                error = "Channel Type is required";
            }
        }
        if(name === 'user_name'){
            if (!value) {
                error = "User name is required";
            }
        }
        if(name === 'password'){
            if (!value) {
                error = "Password is required";
            }
        }
        return error;
    };

    const [addAgentFormError, setAddAgentFormError] = useState({});
    const inputChangeHandler = (selectedOption, actionMeta) => {
        if (actionMeta?.name) {
            const { name } = actionMeta;
            const fieldError = validateField(name, selectedOption);
            setAddAgentFormError((prevErrors) => ({
                ...prevErrors,
                [name]: fieldError,
            }));

            if(actionMeta.name === 'channel_type'){
                setAgentFormData((prevData) => ({
                    ...prevData,
                    [name]: [selectedOption],
                }));
            }
            else{
                setAgentFormData((prevData) => ({
                    ...prevData,
                    [name]: selectedOption,
                }));
            }
        }
        else if (selectedOption?.target) {
            const { name, type, value, checked } = selectedOption.target;
            const inputValue = type === "checkbox" ? (checked ? "Y" : "N") : value;
            const fieldError = validateField(name, inputValue);
            setAddAgentFormError((prevErrors) => ({
                ...prevErrors,
                [name]: fieldError,
            }));
            setAgentFormData((prevData) => ({
                ...prevData,
                [name]: inputValue,
            }));
        }
    };

    const [isShowButtonLoader, setIsShowButtonLoader] = useState(false)
    const formSubmitHandler = async (e) => {
        e.preventDefault();
        const newErrors = {};
        for (const key in agentFormData) {
            newErrors[key] = validateField(key, agentFormData[key]);
        }
        setAddAgentFormError(newErrors);
        if (Object.keys(newErrors).every((key) => !newErrors[key])) {
            let apiToken = '';
            if(loginUserType === 'A') {
                apiToken = localStorage.getItem('token')
            } else if(loginUserType === 'SA') {
                apiToken = localStorage.getItem('systemAdminToken')
            }

            setIsShowButtonLoader(true)
            const api_headers = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "x-access-token" : apiToken
                }
            };
            await axios.post(`${api_base_url}admin/add-agent`, agentFormData, api_headers)
            .then(async (res) => {
                if(res.data.status === 'success') {
                    setAgentFormData({
                        full_name : "", 
                        agent_email : "" ,
                        assign_bot : [],
                        channel_type: [],
                        user_name : "",
                        password : "",
                        agent_update_id : "",
                        agent_old_user_name : ""
                    });
                    setAddAgentFormError({});
                    api["success"]({
                        message: 'Success',
                        description: res.data.message
                    });
                    props.formSubmited();
                    setIsVisible(false);
                } else if(res.data.status === 'error') {
                    api["error"]({
                        message: 'Error',
                        description: res.data.message
                    });
                }
            })
            .catch((error) => {
                console.error(error);
            })
            setIsShowButtonLoader(false)
        }
    }

    useEffect(() => {
        if(Object.keys(agentUpdateData).length > 0){
            var updateAssignBot = botData.filter(item => agentUpdateData.assign_bot.includes(item.value));
            var updateChanneltype = channelList.filter(item => agentUpdateData.channel.includes(item.value));

            setAgentFormData({
                full_name : agentUpdateData.agent_full_name,
                agent_email : agentUpdateData.agent_email ,
                assign_bot : updateAssignBot,
                channel_type: updateChanneltype,
                user_name : agentUpdateData.username,
                password : atob(agentUpdateData.password),
                agent_update_id : agentUpdateData.unique_id,
                agent_old_user_name : agentUpdateData.username,
                sass_id: localStorage.getItem('sass_id'),
                type: loginUserType,
                login_user_name: loginUserType == 'SA' ? localStorage.getItem('system_username') : ''
            });
        }
    },[agentUpdateData])

    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <div className="card card-flush border" id="user_add_card">
                        <div className="card-header py-3">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label fw-bold text-gray-800 fs-2">
                                    Live Assistant
                                </span>
                                <span className="text-gray-400 mt-1 fw-semibold fs-6">
                                    Total {totalAgentCount} assistant are available
                                </span>
                            </h3>
                            {!isVisible ? 
                                <div className="card-toolbar">
                                    <div className="d-flex flex-stack flex-wrap gap-4">
                                        <div className="position-relative my-1 m-w-100">
                                            <SAISVG path="media/icons/duotune/general/gen004.svg" className="svg-icon-muted svg-icon-2 position-absolute top-50 translate-middle-y ms-4" />
                                            <input 
                                                type="text" 
                                                className="form-control form-control-solid ps-12 search-user" placeholder="Search" 
                                                onChange={props.agentSearchInput}
                                            />
                                        </div>
                                        <div className="d-flex align-items-center fw-bold">
                                            <a 
                                                className="btn btn-dark px-6 add-new-user"
                                                onClick={AddAgentHandler}
                                            >
                                                Add Assistant
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            :''}
                        </div>
                        
                        {isVisible ? 
                            <div className={`card-body pt-0 ${customStyle.contentBody} ${isVisible ? customStyle.slideDown : customStyle.slideUp}`}>
                                <form onSubmit={formSubmitHandler}>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="mb-10">
                                                <label className="form-label required">
                                                    Full Name
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control form-control-solid ${addAgentFormError.full_name ? 'is-invalid' : ''}`}
                                                    placeholder="Enter full name"
                                                    name='full_name'
                                                    onChange={inputChangeHandler}
                                                    value={agentFormData.full_name}
                                                    autoFocus={true}
                                                />
                                                {addAgentFormError.full_name && <ValidationMessage className='text-danger' message ={addAgentFormError.full_name}/>}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="mb-10">
                                                <label className="form-label required">
                                                    Channel Type
                                                </label>
                                                <Select 
                                                    className='react-select-styled react-select-solid' 
                                                    classNamePrefix='react-select' 
                                                    placeholder='Select Channel' 
                                                    options={channelList}
                                                    name='channel_type'
                                                    onChange={inputChangeHandler}
                                                    value={agentFormData.channel_type}
                                                />
                                                {addAgentFormError.channel_type && <ValidationMessage className='text-danger' message ={addAgentFormError.channel_type}/>}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="mb-10">
                                                <label className="form-label required">
                                                    Select Bot
                                                </label>
                                                <Select
                                                    className='react-select-styled react-select-solid' 
                                                    classNamePrefix='react-select' 
                                                    options={botData} 
                                                    placeholder='Select Bot' 
                                                    name='assign_bot'
                                                    isClearable
                                                    isMulti
                                                    onChange={inputChangeHandler}
                                                    value={agentFormData.assign_bot}
                                                />
                                                {addAgentFormError.assign_bot && <ValidationMessage className='text-danger' message ={addAgentFormError.assign_bot}/>}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="mb-10">
                                                <label className="form-label required">
                                                    Agent Email
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control form-control-solid ${addAgentFormError.agent_email ? 'is-invalid': ''}`}
                                                    placeholder="Enter email"
                                                    name='agent_email'
                                                    onChange={inputChangeHandler}
                                                    value={agentFormData.agent_email}
                                                />
                                                {addAgentFormError.agent_email && <ValidationMessage className='text-danger' message ={addAgentFormError.agent_email}/>}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="mb-10">
                                                <label className="form-label required">
                                                    Username
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control form-control-solid ${addAgentFormError.user_name ? 'is-invalid' : ''}`}
                                                    placeholder="Enter username"
                                                    name='user_name'
                                                    onChange={inputChangeHandler}
                                                    value={agentFormData.user_name}
                                                />
                                                {addAgentFormError.user_name && <ValidationMessage className='text-danger' message ={addAgentFormError.user_name}/>}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="mb-10">
                                                <label className="form-label required">
                                                    Password
                                                </label>
                                                <div className="input-group input-group-solid mb-5">
                                                    <input 
                                                        type="text" 
                                                        className={`form-control ${!passwordShown ? 'inp-secure' : ''} ${addAgentFormError.password ? 'is-invalid' : ''}`}
                                                        placeholder="Enter password"
                                                        name='password'
                                                        onChange={inputChangeHandler}
                                                        value={agentFormData.password}
                                                    />
                                                    <span className="input-group-text">
                                                        { !passwordShown && 
                                                            <FontAwesomeIcon 
                                                                icon={faEye} 
                                                                className='fs-4 cursor-pointer'
                                                                onClick={ togglePasswordVisibility }
                                                            />
                                                        }
                                                        { passwordShown && 
                                                            <FontAwesomeIcon 
                                                                icon={faEyeSlash} 
                                                                className='fs-4 cursor-pointer'
                                                                onClick={ togglePasswordVisibility }
                                                            />
                                                        }
                                                    </span>
                                                </div>
                                                {addAgentFormError.password && <ValidationMessage className='text-danger' message ={addAgentFormError.password}/>}
                                            </div>
                                        </div>
                                        <div className="col-md-12 text-end">
                                            <button 
                                                className="btn btn-light me-4" 
                                                onClick={(e) => { e.preventDefault(); AgentFormCloseHandler()}}
                                            >
                                                Close
                                            </button>
                                            <button 
                                                className={`btn btn-dark ${isShowButtonLoader && 'disabled'}`} 
                                                type="submit"
                                            >
                                                {
                                                    isShowButtonLoader ? <ButtonLoader btnHtml='Please wait...' className='me-2'/> : 'Save'
                                                }
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        :''}
                    </div>
                </div>
            </div>
            {contextHolder}
        </>
    )
}

export default AgentAddForm